import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ overline, title, subtitle, crumbs = [] }) {
  return (
    <section className="bg-white pt-32 pb-12 md:pt-40 md:pb-16 relative overflow-hidden border-b border-gray-200" data-testid="page-header">
      <div className="absolute inset-0 hero-grid" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <nav className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-gray-400 mb-8" data-testid="breadcrumbs">
          <Link to="/" className="hover:text-gold">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="h-3 w-3" />
              {c.url ? <Link to={c.url} className="hover:text-gold">{c.name}</Link> : <span className="text-gold">{c.name}</span>}
            </span>
          ))}
        </nav>
        {overline && (
          <p className="inline-flex items-center gap-2.5 font-mono text-[11px] md:text-xs uppercase tracking-[0.25em] font-bold text-gold mb-5">
            <span className="h-2 w-2 bg-gold inline-block" />
            {overline}
          </p>
        )}
        <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-black tracking-tighter text-navy leading-[0.98] max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-gray-600 text-base md:text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
